import { render, staticRenderFns } from "./BirthdaySection.vue?vue&type=template&id=2bde5fc6&scoped=true"
import script from "./BirthdaySection.vue?vue&type=script&lang=js"
export * from "./BirthdaySection.vue?vue&type=script&lang=js"
import style0 from "./BirthdaySection.vue?vue&type=style&index=0&id=2bde5fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde5fc6",
  null
  
)

export default component.exports